export function profilePdfPath(profile, lang) {
    if (!profile || profile.published === false) return "";
    if (lang === "ar") {
        return profile.pdf_path_ar || profile.pdf_path || profile.pdf_path_en || "";
    }
    return profile.pdf_path_en || profile.pdf_path || profile.pdf_path_ar || "";
}

export function profilePdfFilename(profile, lang) {
    if (!profile) return "";
    if (lang === "ar") {
        return profile.pdf_filename_ar || profile.pdf_filename || profile.pdf_filename_en || "";
    }
    return profile.pdf_filename_en || profile.pdf_filename || profile.pdf_filename_ar || "";
}
